interface jobDetailsPageProps {
  jobDetails?: any;
  isPremiumUser?: any;
  isLoggedIn?: any;
  themeType?: any;
  isFreeJob?: any;
  deviceType?: any;
  breadCrumbProps?: any;
  isJobDetailsPage?: any;
  handleBackBtn?: any;
  localization?: any;
  saveJobState?: any;
  isExperiment?: any;
  breadCrumbNameWithCategories?: any;
  basePathRewrite?: any;
  isSecondaryModalPopup?: any;
  handleApplyJob?: any;
  trackJobSearchResult?: any;
  cetgoriesCount?: any;
  hiring_count?: any;
  similarJobs?: any;
  similarJobCategoryName?: string;
  userInteractExpId?: boolean;
}
export default function jobDetailsPageProps(props: jobDetailsPageProps) {
  const {
    jobDetails,
    isPremiumUser,
    isLoggedIn,
    themeType,
    isFreeJob,
    deviceType,
    breadCrumbProps,
    isJobDetailsPage,
    handleBackBtn,
    localization,
    saveJobState,
    isExperiment,
    breadCrumbNameWithCategories,
    basePathRewrite,
    isSecondaryModalPopup,
    handleApplyJob,
    trackJobSearchResult,
    cetgoriesCount,
    hiring_count,
    similarJobs,
    userInteractExpId,
    similarJobCategoryName,
  } = props;
  return {
    jobDetails,
    isPremiumUser,
    isLoggedIn,
    themeType,
    isFreeJob,
    deviceType,
    breadCrumbProps,
    isJobDetailsPage,
    handleBackBtn,
    localization,
    saveJobState,
    isExperiment,
    breadCrumbNameWithCategories,
    basePathRewrite,
    isSecondaryModalPopup,
    handleApplyJob,
    trackJobSearchResult,
    cetgoriesCount,
    hiring_count,
    similarJobs,
    similarJobCategoryName,
    userInteractExpId,
  };
}
